/**
 * Rewrites PPT/asset URLs to the current origin so they load through the
 * /digital-classroom/ppt Cloudflare proxy (required for cross-origin isolation).
 */
const getSameOriginUrl = (url: string): string => {
    try {
        const originalURL = new URL(url)
        originalURL.protocol = location.protocol
        originalURL.host = location.host

        return originalURL.href
    } catch {
        return url
    }
}

export { getSameOriginUrl }
